(() => {
  document.documentElement.classList.remove('no-js');

  /* Featured cakes: click to switch, instantly. No hover switching, lens, observer or view transition. */
  const connect = (section) => {
    if (!section || section.dataset.cakeSwitchConnected === 'true') return;

    const panels = [...section.querySelectorAll('[data-cake-panel]')];
    const keys = [...section.querySelectorAll('[data-cake-key]')];
    if (!panels.length || panels.length !== keys.length) return;
    section.dataset.cakeSwitchConnected = 'true';

    const apply = (index) => {
      panels.forEach((panel, i) => {
        const active = i === index;
        panel.classList.toggle('is-active', active);
        panel.classList.remove('is-lens');
        panel.setAttribute('aria-hidden', String(!active));
      });
      keys.forEach((key, i) => {
        const active = i === index;
        key.classList.toggle('is-active', active);
        key.setAttribute('aria-pressed', String(active));
      });
    };

    keys.forEach((key, index) => key.addEventListener('click', () => apply(index)));
  };

  document.querySelectorAll('[data-cake-switch]').forEach(connect);
  document.addEventListener('shopify:section:load', (event) => {
    connect(event.target.querySelector?.('[data-cake-switch]'));
  });
})();
